import { render, staticRenderFns } from "./lose-password.vue?vue&type=template&id=2b6ff8f6&scoped=true&"
import script from "./lose-password.vue?vue&type=script&lang=js&"
export * from "./lose-password.vue?vue&type=script&lang=js&"
import style0 from "./lose-password.vue?vue&type=style&index=0&id=2b6ff8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ff8f6",
  null
  
)

export default component.exports